!(function () {
    "use strict";
    class t extends window.theme.DeferredMedia {
        constructor() {
            super();
        }
        loadContent() {
            super.loadContent(),
                Shopify.loadFeatures([
                    { name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) },
                ]);
        }
        setupModelViewerUI(t) {
            t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")));
        }
    }
    (window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(t) {
            t ||
                (window.ShopifyXR
                    ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((t) => {
                          window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
        window.addEventListener("DOMContentLoaded", () => {
            window.ProductModel && window.ProductModel.loadShopifyXR();
        });
    var e,
        i =
            "undefined" != typeof globalThis
                ? globalThis
                : "undefined" != typeof window
                  ? window
                  : "undefined" != typeof global
                    ? global
                    : "undefined" != typeof self
                      ? self
                      : {},
        s = { exports: {} },
        n = { exports: {} },
        o = { exports: {} };
    (e = o),
        (function (t, i) {
            e.exports ? (e.exports = i()) : (t.EvEmitter = i());
        })("undefined" != typeof window ? window : i, function () {
            function t() {}
            let e = t.prototype;
            return (
                (e.on = function (t, e) {
                    if (!t || !e) return this;
                    let i = (this._events = this._events || {}),
                        s = (i[t] = i[t] || []);
                    return s.includes(e) || s.push(e), this;
                }),
                (e.once = function (t, e) {
                    if (!t || !e) return this;
                    this.on(t, e);
                    let i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                }),
                (e.off = function (t, e) {
                    let i = this._events && this._events[t];
                    if (!i || !i.length) return this;
                    let s = i.indexOf(e);
                    return -1 != s && i.splice(s, 1), this;
                }),
                (e.emitEvent = function (t, e) {
                    let i = this._events && this._events[t];
                    if (!i || !i.length) return this;
                    (i = i.slice(0)), (e = e || []);
                    let s = this._onceEvents && this._onceEvents[t];
                    for (let n of i) s && s[n] && (this.off(t, n), delete s[n]), n.apply(this, e);
                    return this;
                }),
                (e.allOff = function () {
                    return delete this._events, delete this._onceEvents, this;
                }),
                t
            );
        });
    var r = { exports: {} };
    /*!
     * Infinite Scroll v2.0.4
     * measure size of elements
     * MIT license
     */ !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.getSize = i());
        })(window, function () {
            function t(t) {
                let e = parseFloat(t);
                return -1 == t.indexOf("%") && !isNaN(e) && e;
            }
            let e = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
            ];
            return function (i) {
                if (
                    ("string" == typeof i && (i = document.querySelector(i)),
                    !(i && "object" == typeof i && i.nodeType))
                )
                    return;
                let s = getComputedStyle(i);
                if ("none" == s.display)
                    return (function () {
                        let t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 };
                        return (
                            e.forEach((e) => {
                                t[e] = 0;
                            }),
                            t
                        );
                    })();
                let n = {};
                (n.width = i.offsetWidth), (n.height = i.offsetHeight);
                let o = (n.isBorderBox = "border-box" == s.boxSizing);
                e.forEach((t) => {
                    let e = s[t],
                        i = parseFloat(e);
                    n[t] = isNaN(i) ? 0 : i;
                });
                let r = n.paddingLeft + n.paddingRight,
                    l = n.paddingTop + n.paddingBottom,
                    a = n.marginLeft + n.marginRight,
                    h = n.marginTop + n.marginBottom,
                    c = n.borderLeftWidth + n.borderRightWidth,
                    d = n.borderTopWidth + n.borderBottomWidth,
                    u = t(s.width);
                !1 !== u && (n.width = u + (o ? 0 : r + c));
                let p = t(s.height);
                return (
                    !1 !== p && (n.height = p + (o ? 0 : l + d)),
                    (n.innerWidth = n.width - (r + c)),
                    (n.innerHeight = n.height - (l + d)),
                    (n.outerWidth = n.width + a),
                    (n.outerHeight = n.height + h),
                    n
                );
            };
        });
    })(r);
    var l = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(e)) : (e.fizzyUIUtils = i(e));
        })(i, function (t) {
            let e = {
                    extend: function (t, e) {
                        return Object.assign(t, e);
                    },
                    modulo: function (t, e) {
                        return ((t % e) + e) % e;
                    },
                    makeArray: function (t) {
                        if (Array.isArray(t)) return t;
                        if (null == t) return [];
                        return "object" == typeof t && "number" == typeof t.length ? [...t] : [t];
                    },
                    removeFrom: function (t, e) {
                        let i = t.indexOf(e);
                        -1 != i && t.splice(i, 1);
                    },
                    getParent: function (t, e) {
                        for (; t.parentNode && t != document.body; ) if ((t = t.parentNode).matches(e)) return t;
                    },
                    getQueryElement: function (t) {
                        return "string" == typeof t ? document.querySelector(t) : t;
                    },
                    handleEvent: function (t) {
                        let e = "on" + t.type;
                        this[e] && this[e](t);
                    },
                    filterFindElements: function (t, i) {
                        return (t = e.makeArray(t))
                            .filter((t) => t instanceof HTMLElement)
                            .reduce((t, e) => {
                                if (!i) return t.push(e), t;
                                e.matches(i) && t.push(e);
                                let s = e.querySelectorAll(i);
                                return (t = t.concat(...s));
                            }, []);
                    },
                    debounceMethod: function (t, e, i) {
                        i = i || 100;
                        let s = t.prototype[e],
                            n = e + "Timeout";
                        t.prototype[e] = function () {
                            clearTimeout(this[n]);
                            let t = arguments;
                            this[n] = setTimeout(() => {
                                s.apply(this, t), delete this[n];
                            }, i);
                        };
                    },
                    docReady: function (t) {
                        let e = document.readyState;
                        "complete" == e || "interactive" == e
                            ? setTimeout(t)
                            : document.addEventListener("DOMContentLoaded", t);
                    },
                    toDashed: function (t) {
                        return t
                            .replace(/(.)([A-Z])/g, function (t, e, i) {
                                return e + "-" + i;
                            })
                            .toLowerCase();
                    },
                },
                i = t.console;
            return (
                (e.htmlInit = function (s, n) {
                    e.docReady(function () {
                        let o = "data-" + e.toDashed(n),
                            r = document.querySelectorAll(`[${o}]`),
                            l = t.jQuery;
                        [...r].forEach((t) => {
                            let e,
                                r = t.getAttribute(o);
                            try {
                                e = r && JSON.parse(r);
                            } catch (e) {
                                return void (i && i.error(`Error parsing ${o} on ${t.className}: ${e}`));
                            }
                            let a = new s(t, e);
                            l && l.data(t, n, a);
                        });
                    });
                }),
                e
            );
        });
    })(l);
    var a = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports
                ? (t.exports = i(r.exports))
                : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = i(e.getSize)));
        })("undefined" != typeof window ? window : i, function (t) {
            const e = "flickity-cell";
            function i(t) {
                (this.element = t), this.element.classList.add(e), (this.x = 0), this.unselect();
            }
            let s = i.prototype;
            return (
                (s.destroy = function () {
                    this.unselect(),
                        this.element.classList.remove(e),
                        (this.element.style.transform = ""),
                        this.element.removeAttribute("aria-hidden");
                }),
                (s.getSize = function () {
                    this.size = t(this.element);
                }),
                (s.select = function () {
                    this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
                }),
                (s.unselect = function () {
                    this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
                }),
                (s.remove = function () {
                    this.element.remove();
                }),
                i
            );
        });
    })(a);
    var h = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i()) : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = i()));
        })("undefined" != typeof window ? window : i, function () {
            function t(t, e, i) {
                (this.beginMargin = t),
                    (this.endMargin = e),
                    (this.cellAlign = i),
                    (this.cells = []),
                    (this.outerWidth = 0),
                    (this.height = 0);
            }
            let e = t.prototype;
            return (
                (e.addCell = function (t) {
                    this.cells.push(t),
                        (this.outerWidth += t.size.outerWidth),
                        (this.height = Math.max(t.size.outerHeight, this.height)),
                        1 === this.cells.length && ((this.x = t.x), (this.firstMargin = t.size[this.beginMargin]));
                }),
                (e.updateTarget = function () {
                    let t = this.getLastCell(),
                        e = t ? t.size[this.endMargin] : 0,
                        i = this.outerWidth - (this.firstMargin + e);
                    this.target = this.x + this.firstMargin + i * this.cellAlign;
                }),
                (e.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                }),
                (e.select = function () {
                    this.cells.forEach((t) => t.select());
                }),
                (e.unselect = function () {
                    this.cells.forEach((t) => t.unselect());
                }),
                (e.getCellElements = function () {
                    return this.cells.map((t) => t.element);
                }),
                t
            );
        });
    })(h);
    var c = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports
                ? (t.exports = i(l.exports))
                : ((e.Flickity = e.Flickity || {}), (e.Flickity.animatePrototype = i(e.fizzyUIUtils)));
        })("undefined" != typeof window ? window : i, function (t) {
            let e = {
                startAnimation: function () {
                    this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
                },
                animate: function () {
                    this.applyDragForce(), this.applySelectedAttraction();
                    let t = this.x;
                    this.integratePhysics(),
                        this.positionSlider(),
                        this.settle(t),
                        this.isAnimating && requestAnimationFrame(() => this.animate());
                },
                positionSlider: function () {
                    let e = this.x;
                    this.isWrapping &&
                        ((e = t.modulo(e, this.slideableWidth) - this.slideableWidth), this.shiftWrapCells(e)),
                        this.setTranslateX(e, this.isAnimating),
                        this.dispatchScrollEvent();
                },
                setTranslateX: function (t, e) {
                    (t += this.cursorPosition), this.options.rightToLeft && (t = -t);
                    let i = this.getPositionValue(t);
                    this.slider.style.transform = e ? `translate3d(${i},0,0)` : `translateX(${i})`;
                },
                dispatchScrollEvent: function () {
                    let t = this.slides[0];
                    if (!t) return;
                    let e = -this.x - t.target,
                        i = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i, e]);
                },
                positionSliderAtSelected: function () {
                    this.cells.length &&
                        ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
                },
                getPositionValue: function (t) {
                    return this.options.percentPosition
                        ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
                        : Math.round(t) + "px";
                },
                settle: function (t) {
                    !this.isPointerDown && Math.round(100 * this.x) === Math.round(100 * t) && this.restingFrames++,
                        this.restingFrames > 2 &&
                            ((this.isAnimating = !1),
                            delete this.isFreeScrolling,
                            this.positionSlider(),
                            this.dispatchEvent("settle", null, [this.selectedIndex]));
                },
                shiftWrapCells: function (t) {
                    let e = this.cursorPosition + t;
                    this._shiftCells(this.beforeShiftCells, e, -1);
                    let i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, i, 1);
                },
                _shiftCells: function (t, e, i) {
                    t.forEach((t) => {
                        let s = e > 0 ? i : 0;
                        this._wrapShiftCell(t, s), (e -= t.size.outerWidth);
                    });
                },
                _unshiftCells: function (t) {
                    t && t.length && t.forEach((t) => this._wrapShiftCell(t, 0));
                },
                _wrapShiftCell: function (t, e) {
                    this._renderCellPosition(t, t.x + this.slideableWidth * e);
                },
                integratePhysics: function () {
                    (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
                },
                applyForce: function (t) {
                    this.velocity += t;
                },
                getFrictionFactor: function () {
                    return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
                },
                getRestingPosition: function () {
                    return this.x + this.velocity / (1 - this.getFrictionFactor());
                },
                applyDragForce: function () {
                    if (!this.isDraggable || !this.isPointerDown) return;
                    let t = this.dragX - this.x - this.velocity;
                    this.applyForce(t);
                },
                applySelectedAttraction: function () {
                    if ((this.isDraggable && this.isPointerDown) || this.isFreeScrolling || !this.slides.length) return;
                    let t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                    this.applyForce(t);
                },
            };
            return e;
        });
    })(c),
        (function (t) {
            !(function (e, i) {
                if (t.exports) t.exports = i(e, o.exports, r.exports, l.exports, a.exports, h.exports, c.exports);
                else {
                    let t = e.Flickity;
                    e.Flickity = i(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype);
                }
            })("undefined" != typeof window ? window : i, function (t, e, i, s, n, o, r) {
                const { getComputedStyle: l, console: a } = t;
                let { jQuery: h } = t,
                    c = 0,
                    d = {};
                function u(t, e) {
                    let i = s.getQueryElement(t);
                    if (i) {
                        if (((this.element = i), this.element.flickityGUID)) {
                            let t = d[this.element.flickityGUID];
                            return t && t.option(e), t;
                        }
                        h && (this.$element = h(this.element)),
                            (this.options = { ...this.constructor.defaults }),
                            this.option(e),
                            this._create();
                    } else a && a.error(`Bad element for Flickity: ${i || t}`);
                }
                (u.defaults = {
                    accessibility: !0,
                    cellAlign: "center",
                    freeScrollFriction: 0.075,
                    friction: 0.28,
                    namespaceJQueryEvents: !0,
                    percentPosition: !0,
                    resize: !0,
                    selectedAttraction: 0.025,
                    setGallerySize: !0,
                }),
                    (u.create = {});
                let p = u.prototype;
                Object.assign(p, e.prototype),
                    (p._create = function () {
                        let { resize: e, watchCSS: i, rightToLeft: s } = this.options,
                            n = (this.guid = ++c);
                        (this.element.flickityGUID = n),
                            (d[n] = this),
                            (this.selectedIndex = 0),
                            (this.restingFrames = 0),
                            (this.x = 0),
                            (this.velocity = 0),
                            (this.beginMargin = s ? "marginRight" : "marginLeft"),
                            (this.endMargin = s ? "marginLeft" : "marginRight"),
                            (this.viewport = document.createElement("div")),
                            (this.viewport.className = "flickity-viewport"),
                            this._createSlider(),
                            (this.focusableElems = [this.element]),
                            (e || i) && t.addEventListener("resize", this);
                        for (let t in this.options.on) {
                            let e = this.options.on[t];
                            this.on(t, e);
                        }
                        for (let t in u.create) u.create[t].call(this);
                        i ? this.watchCSS() : this.activate();
                    }),
                    (p.option = function (t) {
                        Object.assign(this.options, t);
                    }),
                    (p.activate = function () {
                        if (this.isActive) return;
                        (this.isActive = !0),
                            this.element.classList.add("flickity-enabled"),
                            this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                            this.getSize();
                        let t = this._filterFindCellElements(this.element.children);
                        this.slider.append(...t),
                            this.viewport.append(this.slider),
                            this.element.append(this.viewport),
                            this.reloadCells(),
                            this.options.accessibility &&
                                ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                            this.emitEvent("activate"),
                            this.selectInitialIndex(),
                            (this.isInitActivated = !0),
                            this.dispatchEvent("ready");
                    }),
                    (p._createSlider = function () {
                        let t = document.createElement("div");
                        (t.className = "flickity-slider"), (this.slider = t);
                    }),
                    (p._filterFindCellElements = function (t) {
                        return s.filterFindElements(t, this.options.cellSelector);
                    }),
                    (p.reloadCells = function () {
                        (this.cells = this._makeCells(this.slider.children)),
                            this.positionCells(),
                            this._updateWrapShiftCells(),
                            this.setGallerySize();
                    }),
                    (p._makeCells = function (t) {
                        return this._filterFindCellElements(t).map((t) => new n(t));
                    }),
                    (p.getLastCell = function () {
                        return this.cells[this.cells.length - 1];
                    }),
                    (p.getLastSlide = function () {
                        return this.slides[this.slides.length - 1];
                    }),
                    (p.positionCells = function () {
                        this._sizeCells(this.cells), this._positionCells(0);
                    }),
                    (p._positionCells = function (t) {
                        (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                        let e = 0;
                        if (t > 0) {
                            let i = this.cells[t - 1];
                            e = i.x + i.size.outerWidth;
                        }
                        this.cells.slice(t).forEach((t) => {
                            (t.x = e),
                                this._renderCellPosition(t, e),
                                (e += t.size.outerWidth),
                                (this.maxCellHeight = Math.max(t.size.outerHeight, this.maxCellHeight));
                        }),
                            (this.slideableWidth = e),
                            this.updateSlides(),
                            this._containSlides(),
                            (this.slidesWidth = this.cells.length
                                ? this.getLastSlide().target - this.slides[0].target
                                : 0);
                    }),
                    (p._renderCellPosition = function (t, e) {
                        let i = e * (this.options.rightToLeft ? -1 : 1);
                        this.options.percentPosition && (i *= this.size.innerWidth / t.size.width);
                        let s = this.getPositionValue(i);
                        t.element.style.transform = `translateX( ${s} )`;
                    }),
                    (p._sizeCells = function (t) {
                        t.forEach((t) => t.getSize());
                    }),
                    (p.updateSlides = function () {
                        if (((this.slides = []), !this.cells.length)) return;
                        let { beginMargin: t, endMargin: e } = this,
                            i = new o(t, e, this.cellAlign);
                        this.slides.push(i);
                        let s = this._getCanCellFit();
                        this.cells.forEach((n, r) => {
                            if (!i.cells.length) return void i.addCell(n);
                            let l = i.outerWidth - i.firstMargin + (n.size.outerWidth - n.size[e]);
                            s(r, l) || (i.updateTarget(), (i = new o(t, e, this.cellAlign)), this.slides.push(i)),
                                i.addCell(n);
                        }),
                            i.updateTarget(),
                            this.updateSelectedSlide();
                    }),
                    (p._getCanCellFit = function () {
                        let { groupCells: t } = this.options;
                        if (!t) return () => !1;
                        if ("number" == typeof t) {
                            let e = parseInt(t, 10);
                            return (t) => t % e !== 0;
                        }
                        let e = 1,
                            i = "string" == typeof t && t.match(/^(\d+)%$/);
                        i && (e = parseInt(i[1], 10) / 100);
                        let s = (this.size.innerWidth + 1) * e;
                        return (t, e) => e <= s;
                    }),
                    (p._init = p.reposition =
                        function () {
                            this.positionCells(), this.positionSliderAtSelected();
                        }),
                    (p.getSize = function () {
                        (this.size = i(this.element)),
                            this.setCellAlign(),
                            (this.cursorPosition = this.size.innerWidth * this.cellAlign);
                    });
                let f = { left: 0, center: 0.5, right: 1 };
                (p.setCellAlign = function () {
                    let { cellAlign: t, rightToLeft: e } = this.options,
                        i = f[t];
                    (this.cellAlign = void 0 !== i ? i : t), e && (this.cellAlign = 1 - this.cellAlign);
                }),
                    (p.setGallerySize = function () {
                        if (!this.options.setGallerySize) return;
                        let t =
                            this.options.adaptiveHeight && this.selectedSlide
                                ? this.selectedSlide.height
                                : this.maxCellHeight;
                        this.viewport.style.height = `${t}px`;
                    }),
                    (p._updateWrapShiftCells = function () {
                        if (((this.isWrapping = this.getIsWrapping()), !this.isWrapping)) return;
                        this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                        let t = this.cursorPosition,
                            e = this.cells.length - 1;
                        this.beforeShiftCells = this._getGapCells(t, e, -1);
                        let i = this.size.innerWidth - this.cursorPosition;
                        this.afterShiftCells = this._getGapCells(i, 0, 1);
                    }),
                    (p.getIsWrapping = function () {
                        let { wrapAround: t } = this.options;
                        if (!t || this.slides.length < 2) return !1;
                        if ("fill" !== t) return !0;
                        let e = this.slideableWidth - this.size.innerWidth;
                        if (e > this.size.innerWidth) return !0;
                        for (let t of this.cells) if (t.size.outerWidth > e) return !1;
                        return !0;
                    }),
                    (p._getGapCells = function (t, e, i) {
                        let s = [];
                        for (; t > 0; ) {
                            let n = this.cells[e];
                            if (!n) break;
                            s.push(n), (e += i), (t -= n.size.outerWidth);
                        }
                        return s;
                    }),
                    (p._containSlides = function () {
                        if (!(this.options.contain && !this.isWrapping && this.cells.length)) return;
                        let t = this.slideableWidth - this.getLastCell().size[this.endMargin];
                        if (t < this.size.innerWidth)
                            this.slides.forEach((e) => {
                                e.target = t * this.cellAlign;
                            });
                        else {
                            let e = this.cursorPosition + this.cells[0].size[this.beginMargin],
                                i = t - this.size.innerWidth * (1 - this.cellAlign);
                            this.slides.forEach((t) => {
                                (t.target = Math.max(t.target, e)), (t.target = Math.min(t.target, i));
                            });
                        }
                    }),
                    (p.dispatchEvent = function (t, e, i) {
                        let s = e ? [e].concat(i) : i;
                        if ((this.emitEvent(t, s), h && this.$element)) {
                            let s = (t += this.options.namespaceJQueryEvents ? ".flickity" : "");
                            if (e) {
                                let i = new h.Event(e);
                                (i.type = t), (s = i);
                            }
                            this.$element.trigger(s, i);
                        }
                    });
                const g = [
                    "dragStart",
                    "dragMove",
                    "dragEnd",
                    "pointerDown",
                    "pointerMove",
                    "pointerEnd",
                    "staticClick",
                ];
                let m = p.emitEvent;
                (p.emitEvent = function (t, e) {
                    if ("staticClick" === t) {
                        let t = this.getParentCell(e[0].target),
                            i = t && t.element,
                            s = t && this.cells.indexOf(t);
                        e = e.concat(i, s);
                    }
                    if ((m.call(this, t, e), !g.includes(t) || !h || !this.$element)) return;
                    t += this.options.namespaceJQueryEvents ? ".flickity" : "";
                    let i = e.shift(0),
                        s = new h.Event(i);
                    (s.type = t), this.$element.trigger(s, e);
                }),
                    (p.select = function (t, e, i) {
                        if (!this.isActive) return;
                        if (
                            ((t = parseInt(t, 10)),
                            this._wrapSelect(t),
                            (this.isWrapping || e) && (t = s.modulo(t, this.slides.length)),
                            !this.slides[t])
                        )
                            return;
                        let n = this.selectedIndex;
                        (this.selectedIndex = t),
                            this.updateSelectedSlide(),
                            i ? this.positionSliderAtSelected() : this.startAnimation(),
                            this.options.adaptiveHeight && this.setGallerySize(),
                            this.dispatchEvent("select", null, [t]),
                            t !== n && this.dispatchEvent("change", null, [t]);
                    }),
                    (p._wrapSelect = function (t) {
                        if (!this.isWrapping) return;
                        const {
                            selectedIndex: e,
                            slideableWidth: i,
                            slides: { length: n },
                        } = this;
                        if (!this.isDragSelect) {
                            let i = s.modulo(t, n),
                                o = Math.abs(i - e),
                                r = Math.abs(i + n - e),
                                l = Math.abs(i - n - e);
                            r < o ? (t += n) : l < o && (t -= n);
                        }
                        t < 0 ? (this.x -= i) : t >= n && (this.x += i);
                    }),
                    (p.previous = function (t, e) {
                        this.select(this.selectedIndex - 1, t, e);
                    }),
                    (p.next = function (t, e) {
                        this.select(this.selectedIndex + 1, t, e);
                    }),
                    (p.updateSelectedSlide = function () {
                        let t = this.slides[this.selectedIndex];
                        t &&
                            (this.unselectSelectedSlide(),
                            (this.selectedSlide = t),
                            t.select(),
                            (this.selectedCells = t.cells),
                            (this.selectedElements = t.getCellElements()),
                            (this.selectedCell = t.cells[0]),
                            (this.selectedElement = this.selectedElements[0]));
                    }),
                    (p.unselectSelectedSlide = function () {
                        this.selectedSlide && this.selectedSlide.unselect();
                    }),
                    (p.selectInitialIndex = function () {
                        let t = this.options.initialIndex;
                        if (this.isInitActivated) return void this.select(this.selectedIndex, !1, !0);
                        if (t && "string" == typeof t) {
                            if (this.queryCell(t)) return void this.selectCell(t, !1, !0);
                        }
                        let e = 0;
                        t && this.slides[t] && (e = t), this.select(e, !1, !0);
                    }),
                    (p.selectCell = function (t, e, i) {
                        let s = this.queryCell(t);
                        if (!s) return;
                        let n = this.getCellSlideIndex(s);
                        this.select(n, e, i);
                    }),
                    (p.getCellSlideIndex = function (t) {
                        let e = this.slides.find((e) => e.cells.includes(t));
                        return this.slides.indexOf(e);
                    }),
                    (p.getCell = function (t) {
                        for (let e of this.cells) if (e.element === t) return e;
                    }),
                    (p.getCells = function (t) {
                        return (t = s.makeArray(t)).map((t) => this.getCell(t)).filter(Boolean);
                    }),
                    (p.getCellElements = function () {
                        return this.cells.map((t) => t.element);
                    }),
                    (p.getParentCell = function (t) {
                        let e = this.getCell(t);
                        if (e) return e;
                        let i = t.closest(".flickity-slider > *");
                        return this.getCell(i);
                    }),
                    (p.getAdjacentCellElements = function (t, e) {
                        if (!t) return this.selectedSlide.getCellElements();
                        e = void 0 === e ? this.selectedIndex : e;
                        let i = this.slides.length;
                        if (1 + 2 * t >= i) return this.getCellElements();
                        let n = [];
                        for (let o = e - t; o <= e + t; o++) {
                            let t = this.isWrapping ? s.modulo(o, i) : o,
                                e = this.slides[t];
                            e && (n = n.concat(e.getCellElements()));
                        }
                        return n;
                    }),
                    (p.queryCell = function (t) {
                        if ("number" == typeof t) return this.cells[t];
                        return (
                            "string" == typeof t && !t.match(/^[#.]?[\d/]/) && (t = this.element.querySelector(t)),
                            this.getCell(t)
                        );
                    }),
                    (p.uiChange = function () {
                        this.emitEvent("uiChange");
                    }),
                    (p.onresize = function () {
                        this.watchCSS(), this.resize();
                    }),
                    s.debounceMethod(u, "onresize", 150),
                    (p.resize = function () {
                        if (!this.isActive || this.isAnimating || this.isDragging) return;
                        this.getSize(),
                            this.isWrapping && (this.x = s.modulo(this.x, this.slideableWidth)),
                            this.positionCells(),
                            this._updateWrapShiftCells(),
                            this.setGallerySize(),
                            this.emitEvent("resize");
                        let t = this.selectedElements && this.selectedElements[0];
                        this.selectCell(t, !1, !0);
                    }),
                    (p.watchCSS = function () {
                        if (!this.options.watchCSS) return;
                        l(this.element, ":after").content.includes("flickity") ? this.activate() : this.deactivate();
                    }),
                    (p.onkeydown = function (t) {
                        let { activeElement: e } = document,
                            i = u.keyboardHandlers[t.key];
                        this.options.accessibility &&
                            e &&
                            i &&
                            this.focusableElems.some((t) => e === t) &&
                            i.call(this);
                    }),
                    (u.keyboardHandlers = {
                        ArrowLeft: function () {
                            this.uiChange(), this[this.options.rightToLeft ? "next" : "previous"]();
                        },
                        ArrowRight: function () {
                            this.uiChange(), this[this.options.rightToLeft ? "previous" : "next"]();
                        },
                    }),
                    (p.focus = function () {
                        this.element.focus({ preventScroll: !0 });
                    }),
                    (p.deactivate = function () {
                        this.isActive &&
                            (this.element.classList.remove("flickity-enabled"),
                            this.element.classList.remove("flickity-rtl"),
                            this.unselectSelectedSlide(),
                            this.cells.forEach((t) => t.destroy()),
                            this.viewport.remove(),
                            this.element.append(...this.slider.children),
                            this.options.accessibility &&
                                (this.element.removeAttribute("tabIndex"),
                                this.element.removeEventListener("keydown", this)),
                            (this.isActive = !1),
                            this.emitEvent("deactivate"));
                    }),
                    (p.destroy = function () {
                        this.deactivate(),
                            t.removeEventListener("resize", this),
                            this.allOff(),
                            this.emitEvent("destroy"),
                            h && this.$element && h.removeData(this.element, "flickity"),
                            delete this.element.flickityGUID,
                            delete d[this.guid];
                    }),
                    Object.assign(p, r),
                    (u.data = function (t) {
                        if ((t = s.getQueryElement(t))) return d[t.flickityGUID];
                    }),
                    s.htmlInit(u, "flickity");
                let { jQueryBridget: y } = t;
                return (
                    h && y && y("flickity", u, h),
                    (u.setJQuery = function (t) {
                        h = t;
                    }),
                    (u.Cell = n),
                    (u.Slide = o),
                    u
                );
            });
        })(n);
    var d = { exports: {} };
    /*!
     * Unidragger v3.0.1
     * Draggable base class
     * MIT license
     */
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(e, o.exports)) : (e.Unidragger = i(e, e.EvEmitter));
        })("undefined" != typeof window ? window : i, function (t, e) {
            function i() {}
            let s,
                n,
                o = (i.prototype = Object.create(e.prototype));
            (o.handleEvent = function (t) {
                let e = "on" + t.type;
                this[e] && this[e](t);
            }),
                "ontouchstart" in t
                    ? ((s = "touchstart"), (n = ["touchmove", "touchend", "touchcancel"]))
                    : t.PointerEvent
                      ? ((s = "pointerdown"), (n = ["pointermove", "pointerup", "pointercancel"]))
                      : ((s = "mousedown"), (n = ["mousemove", "mouseup"])),
                (o.touchActionValue = "none"),
                (o.bindHandles = function () {
                    this._bindHandles("addEventListener", this.touchActionValue);
                }),
                (o.unbindHandles = function () {
                    this._bindHandles("removeEventListener", "");
                }),
                (o._bindHandles = function (e, i) {
                    this.handles.forEach((n) => {
                        n[e](s, this), n[e]("click", this), t.PointerEvent && (n.style.touchAction = i);
                    });
                }),
                (o.bindActivePointerEvents = function () {
                    n.forEach((e) => {
                        t.addEventListener(e, this);
                    });
                }),
                (o.unbindActivePointerEvents = function () {
                    n.forEach((e) => {
                        t.removeEventListener(e, this);
                    });
                }),
                (o.withPointer = function (t, e) {
                    e.pointerId === this.pointerIdentifier && this[t](e, e);
                }),
                (o.withTouch = function (t, e) {
                    let i;
                    for (let t of e.changedTouches) t.identifier === this.pointerIdentifier && (i = t);
                    i && this[t](e, i);
                }),
                (o.onmousedown = function (t) {
                    this.pointerDown(t, t);
                }),
                (o.ontouchstart = function (t) {
                    this.pointerDown(t, t.changedTouches[0]);
                }),
                (o.onpointerdown = function (t) {
                    this.pointerDown(t, t);
                });
            const r = ["TEXTAREA", "INPUT", "SELECT", "OPTION"],
                l = ["radio", "checkbox", "button", "submit", "image", "file"];
            return (
                (o.pointerDown = function (t, e) {
                    let i = r.includes(t.target.nodeName),
                        s = l.includes(t.target.type),
                        n = !i || s;
                    !this.isPointerDown &&
                        !t.button &&
                        n &&
                        ((this.isPointerDown = !0),
                        (this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier),
                        (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
                        this.bindActivePointerEvents(),
                        this.emitEvent("pointerDown", [t, e]));
                }),
                (o.onmousemove = function (t) {
                    this.pointerMove(t, t);
                }),
                (o.onpointermove = function (t) {
                    this.withPointer("pointerMove", t);
                }),
                (o.ontouchmove = function (t) {
                    this.withTouch("pointerMove", t);
                }),
                (o.pointerMove = function (t, e) {
                    let i = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
                    this.emitEvent("pointerMove", [t, e, i]),
                        !this.isDragging && this.hasDragStarted(i) && this.dragStart(t, e),
                        this.isDragging && this.dragMove(t, e, i);
                }),
                (o.hasDragStarted = function (t) {
                    return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
                }),
                (o.dragStart = function (t, e) {
                    (this.isDragging = !0), (this.isPreventingClicks = !0), this.emitEvent("dragStart", [t, e]);
                }),
                (o.dragMove = function (t, e, i) {
                    this.emitEvent("dragMove", [t, e, i]);
                }),
                (o.onmouseup = function (t) {
                    this.pointerUp(t, t);
                }),
                (o.onpointerup = function (t) {
                    this.withPointer("pointerUp", t);
                }),
                (o.ontouchend = function (t) {
                    this.withTouch("pointerUp", t);
                }),
                (o.pointerUp = function (t, e) {
                    this.pointerDone(),
                        this.emitEvent("pointerUp", [t, e]),
                        this.isDragging ? this.dragEnd(t, e) : this.staticClick(t, e);
                }),
                (o.dragEnd = function (t, e) {
                    (this.isDragging = !1),
                        setTimeout(() => delete this.isPreventingClicks),
                        this.emitEvent("dragEnd", [t, e]);
                }),
                (o.pointerDone = function () {
                    (this.isPointerDown = !1),
                        delete this.pointerIdentifier,
                        this.unbindActivePointerEvents(),
                        this.emitEvent("pointerDone");
                }),
                (o.onpointercancel = function (t) {
                    this.withPointer("pointerCancel", t);
                }),
                (o.ontouchcancel = function (t) {
                    this.withTouch("pointerCancel", t);
                }),
                (o.pointerCancel = function (t, e) {
                    this.pointerDone(), this.emitEvent("pointerCancel", [t, e]);
                }),
                (o.onclick = function (t) {
                    this.isPreventingClicks && t.preventDefault();
                }),
                (o.staticClick = function (t, e) {
                    let i = "mouseup" === t.type;
                    (i && this.isIgnoringMouseUp) ||
                        (this.emitEvent("staticClick", [t, e]),
                        i &&
                            ((this.isIgnoringMouseUp = !0),
                            setTimeout(() => {
                                delete this.isIgnoringMouseUp;
                            }, 400)));
                }),
                i
            );
        });
    })(d),
        (function (t) {
            !(function (e, i) {
                t.exports
                    ? (t.exports = i(e, n.exports, d.exports, l.exports))
                    : (e.Flickity = i(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
            })("undefined" != typeof window ? window : i, function (t, e, i, s) {
                Object.assign(e.defaults, { draggable: ">1", dragThreshold: 3 });
                let n = e.prototype;
                function o() {
                    return { x: t.pageXOffset, y: t.pageYOffset };
                }
                return (
                    Object.assign(n, i.prototype),
                    (n.touchActionValue = ""),
                    (e.create.drag = function () {
                        this.on("activate", this.onActivateDrag),
                            this.on("uiChange", this._uiChangeDrag),
                            this.on("deactivate", this.onDeactivateDrag),
                            this.on("cellChange", this.updateDraggable),
                            this.on("pointerDown", this.handlePointerDown),
                            this.on("pointerUp", this.handlePointerUp),
                            this.on("pointerDown", this.handlePointerDone),
                            this.on("dragStart", this.handleDragStart),
                            this.on("dragMove", this.handleDragMove),
                            this.on("dragEnd", this.handleDragEnd),
                            this.on("staticClick", this.handleStaticClick);
                    }),
                    (n.onActivateDrag = function () {
                        (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
                    }),
                    (n.onDeactivateDrag = function () {
                        this.unbindHandles(), this.element.classList.remove("is-draggable");
                    }),
                    (n.updateDraggable = function () {
                        ">1" === this.options.draggable
                            ? (this.isDraggable = this.slides.length > 1)
                            : (this.isDraggable = this.options.draggable),
                            this.element.classList.toggle("is-draggable", this.isDraggable);
                    }),
                    (n._uiChangeDrag = function () {
                        delete this.isFreeScrolling;
                    }),
                    (n.handlePointerDown = function (e) {
                        if (!this.isDraggable) return void this.bindActivePointerEvents(e);
                        let i = "touchstart" === e.type,
                            s = "touch" === e.pointerType,
                            n = e.target.matches("input, textarea, select");
                        i || s || n || e.preventDefault(),
                            n || this.focus(),
                            document.activeElement !== this.element && document.activeElement.blur(),
                            (this.dragX = this.x),
                            this.viewport.classList.add("is-pointer-down"),
                            (this.pointerDownScroll = o()),
                            t.addEventListener("scroll", this),
                            this.bindActivePointerEvents(e);
                    }),
                    (n.hasDragStarted = function (t) {
                        return Math.abs(t.x) > this.options.dragThreshold;
                    }),
                    (n.handlePointerUp = function () {
                        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down");
                    }),
                    (n.handlePointerDone = function () {
                        t.removeEventListener("scroll", this), delete this.pointerDownScroll;
                    }),
                    (n.handleDragStart = function () {
                        this.isDraggable &&
                            ((this.dragStartPosition = this.x),
                            this.startAnimation(),
                            t.removeEventListener("scroll", this));
                    }),
                    (n.handleDragMove = function (t, e, i) {
                        if (!this.isDraggable) return;
                        t.preventDefault(), (this.previousDragX = this.dragX);
                        let s = this.options.rightToLeft ? -1 : 1;
                        this.isWrapping && (i.x %= this.slideableWidth);
                        let n = this.dragStartPosition + i.x * s;
                        if (!this.isWrapping) {
                            let t = Math.max(-this.slides[0].target, this.dragStartPosition);
                            n = n > t ? 0.5 * (n + t) : n;
                            let e = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                            n = n < e ? 0.5 * (n + e) : n;
                        }
                        (this.dragX = n), (this.dragMoveTime = new Date());
                    }),
                    (n.handleDragEnd = function () {
                        if (!this.isDraggable) return;
                        let { freeScroll: t } = this.options;
                        t && (this.isFreeScrolling = !0);
                        let e = this.dragEndRestingSelect();
                        if (t && !this.isWrapping) {
                            let t = this.getRestingPosition();
                            this.isFreeScrolling = -t > this.slides[0].target && -t < this.getLastSlide().target;
                        } else t || e !== this.selectedIndex || (e += this.dragEndBoostSelect());
                        delete this.previousDragX,
                            (this.isDragSelect = this.isWrapping),
                            this.select(e),
                            delete this.isDragSelect;
                    }),
                    (n.dragEndRestingSelect = function () {
                        let t = this.getRestingPosition(),
                            e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                            i = this._getClosestResting(t, e, 1),
                            s = this._getClosestResting(t, e, -1);
                        return i.distance < s.distance ? i.index : s.index;
                    }),
                    (n._getClosestResting = function (t, e, i) {
                        let s = this.selectedIndex,
                            n = 1 / 0,
                            o = this.options.contain && !this.isWrapping ? (t, e) => t <= e : (t, e) => t < e;
                        for (; o(e, n) && ((s += i), (n = e), null !== (e = this.getSlideDistance(-t, s))); )
                            e = Math.abs(e);
                        return { distance: n, index: s - i };
                    }),
                    (n.getSlideDistance = function (t, e) {
                        let i = this.slides.length,
                            n = this.options.wrapAround && i > 1,
                            o = n ? s.modulo(e, i) : e,
                            r = this.slides[o];
                        if (!r) return null;
                        let l = n ? this.slideableWidth * Math.floor(e / i) : 0;
                        return t - (r.target + l);
                    }),
                    (n.dragEndBoostSelect = function () {
                        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100)
                            return 0;
                        let t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                            e = this.previousDragX - this.dragX;
                        return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                    }),
                    (n.onscroll = function () {
                        let t = o(),
                            e = this.pointerDownScroll.x - t.x,
                            i = this.pointerDownScroll.y - t.y;
                        (Math.abs(e) > 3 || Math.abs(i) > 3) && this.pointerDone();
                    }),
                    e
                );
            });
        })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(n.exports)) : i(e.Flickity);
        })("undefined" != typeof window ? window : i, function (t) {
            const e = "http://www.w3.org/2000/svg";
            function i(t, e, i) {
                (this.increment = t),
                    (this.direction = e),
                    (this.isPrevious = "previous" === t),
                    (this.isLeft = "left" === e),
                    this._create(i);
            }
            (i.prototype._create = function (t) {
                let e = (this.element = document.createElement("button"));
                e.className = `flickity-button flickity-prev-next-button ${this.increment}`;
                let i = this.isPrevious ? "Previous" : "Next";
                e.setAttribute("type", "button"), e.setAttribute("aria-label", i), this.disable();
                let s = this.createSVG(i, t);
                e.append(s);
            }),
                (i.prototype.createSVG = function (t, i) {
                    let s = document.createElementNS(e, "svg");
                    s.setAttribute("class", "flickity-button-icon"), s.setAttribute("viewBox", "0 0 100 100");
                    let n = document.createElementNS(e, "title");
                    n.append(t);
                    let o = document.createElementNS(e, "path"),
                        r = (function (t) {
                            if ("string" == typeof t) return t;
                            let { x0: e, x1: i, x2: s, x3: n, y1: o, y2: r } = t;
                            return `M ${e}, 50\n    L ${i}, ${o + 50}\n    L ${s}, ${r + 50}\n    L ${n}, 50\n    L ${s}, ${50 - r}\n    L ${i}, ${50 - o}\n    Z`;
                        })(i);
                    return (
                        o.setAttribute("d", r),
                        o.setAttribute("class", "arrow"),
                        this.isLeft || o.setAttribute("transform", "translate(100, 100) rotate(180)"),
                        s.append(n, o),
                        s
                    );
                }),
                (i.prototype.enable = function () {
                    this.element.removeAttribute("disabled");
                }),
                (i.prototype.disable = function () {
                    this.element.setAttribute("disabled", !0);
                }),
                Object.assign(t.defaults, {
                    prevNextButtons: !0,
                    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
                }),
                (t.create.prevNextButtons = function () {
                    if (!this.options.prevNextButtons) return;
                    let { rightToLeft: t, arrowShape: e } = this.options,
                        s = t ? "right" : "left",
                        n = t ? "left" : "right";
                    (this.prevButton = new i("previous", s, e)),
                        (this.nextButton = new i("next", n, e)),
                        this.focusableElems.push(this.prevButton.element),
                        this.focusableElems.push(this.nextButton.element),
                        (this.handlePrevButtonClick = () => {
                            this.uiChange(), this.previous();
                        }),
                        (this.handleNextButtonClick = () => {
                            this.uiChange(), this.next();
                        }),
                        this.on("activate", this.activatePrevNextButtons),
                        this.on("select", this.updatePrevNextButtons);
                });
            let s = t.prototype;
            return (
                (s.updatePrevNextButtons = function () {
                    let t = this.slides.length ? this.slides.length - 1 : 0;
                    this.updatePrevNextButton(this.prevButton, 0), this.updatePrevNextButton(this.nextButton, t);
                }),
                (s.updatePrevNextButton = function (t, e) {
                    if (this.isWrapping && this.slides.length > 1) return void t.enable();
                    let i = this.selectedIndex !== e;
                    t[i ? "enable" : "disable"](), !i && document.activeElement === t.element && this.focus();
                }),
                (s.activatePrevNextButtons = function () {
                    this.prevButton.element.addEventListener("click", this.handlePrevButtonClick),
                        this.nextButton.element.addEventListener("click", this.handleNextButtonClick),
                        this.element.append(this.prevButton.element, this.nextButton.element),
                        this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (s.deactivatePrevNextButtons = function () {
                    this.prevButton.element.remove(),
                        this.nextButton.element.remove(),
                        this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick),
                        this.nextButton.element.removeEventListener("click", this.handleNextButtonClick),
                        this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (t.PrevNextButton = i),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(n.exports, l.exports)) : i(e.Flickity, e.fizzyUIUtils);
        })("undefined" != typeof window ? window : i, function (t, e) {
            function i() {
                (this.holder = document.createElement("div")),
                    (this.holder.className = "flickity-page-dots"),
                    (this.dots = []);
            }
            (i.prototype.setDots = function (t) {
                let e = t - this.dots.length;
                e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e);
            }),
                (i.prototype.addDots = function (t) {
                    let e = new Array(t).fill().map((t, e) => {
                        let i = document.createElement("button");
                        i.setAttribute("type", "button");
                        let s = e + 1 + this.dots.length;
                        return (i.className = "flickity-page-dot"), (i.textContent = `View slide ${s}`), i;
                    });
                    this.holder.append(...e), (this.dots = this.dots.concat(e));
                }),
                (i.prototype.removeDots = function (t) {
                    this.dots.splice(this.dots.length - t, t).forEach((t) => t.remove());
                }),
                (i.prototype.updateSelected = function (t) {
                    this.selectedDot &&
                        (this.selectedDot.classList.remove("is-selected"),
                        this.selectedDot.removeAttribute("aria-current")),
                        this.dots.length &&
                            ((this.selectedDot = this.dots[t]),
                            this.selectedDot.classList.add("is-selected"),
                            this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (t.PageDots = i),
                Object.assign(t.defaults, { pageDots: !0 }),
                (t.create.pageDots = function () {
                    this.options.pageDots &&
                        ((this.pageDots = new i()),
                        (this.handlePageDotsClick = this.onPageDotsClick.bind(this)),
                        this.on("activate", this.activatePageDots),
                        this.on("select", this.updateSelectedPageDots),
                        this.on("cellChange", this.updatePageDots),
                        this.on("resize", this.updatePageDots),
                        this.on("deactivate", this.deactivatePageDots));
                });
            let s = t.prototype;
            return (
                (s.activatePageDots = function () {
                    this.pageDots.setDots(this.slides.length),
                        this.focusableElems.push(...this.pageDots.dots),
                        this.pageDots.holder.addEventListener("click", this.handlePageDotsClick),
                        this.element.append(this.pageDots.holder);
                }),
                (s.onPageDotsClick = function (t) {
                    let e = this.pageDots.dots.indexOf(t.target);
                    -1 !== e && (this.uiChange(), this.select(e));
                }),
                (s.updateSelectedPageDots = function () {
                    this.pageDots.updateSelected(this.selectedIndex);
                }),
                (s.updatePageDots = function () {
                    this.pageDots.dots.forEach((t) => {
                        e.removeFrom(this.focusableElems, t);
                    }),
                        this.pageDots.setDots(this.slides.length),
                        this.focusableElems.push(...this.pageDots.dots);
                }),
                (s.deactivatePageDots = function () {
                    this.pageDots.holder.remove(),
                        this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
                }),
                (t.PageDots = i),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(n.exports)) : i(e.Flickity);
        })("undefined" != typeof window ? window : i, function (t) {
            function e(t, e) {
                (this.autoPlay = t),
                    (this.onTick = e),
                    (this.state = "stopped"),
                    (this.onVisibilityChange = this.visibilityChange.bind(this)),
                    (this.onVisibilityPlay = this.visibilityPlay.bind(this));
            }
            (e.prototype.play = function () {
                if ("playing" === this.state) return;
                document.hidden
                    ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
                    : ((this.state = "playing"),
                      document.addEventListener("visibilitychange", this.onVisibilityChange),
                      this.tick());
            }),
                (e.prototype.tick = function () {
                    if ("playing" !== this.state) return;
                    let t = "number" == typeof this.autoPlay ? this.autoPlay : 3e3;
                    this.clear(),
                        (this.timeout = setTimeout(() => {
                            this.onTick(), this.tick();
                        }, t));
                }),
                (e.prototype.stop = function () {
                    (this.state = "stopped"),
                        this.clear(),
                        document.removeEventListener("visibilitychange", this.onVisibilityChange);
                }),
                (e.prototype.clear = function () {
                    clearTimeout(this.timeout);
                }),
                (e.prototype.pause = function () {
                    "playing" === this.state && ((this.state = "paused"), this.clear());
                }),
                (e.prototype.unpause = function () {
                    "paused" === this.state && this.play();
                }),
                (e.prototype.visibilityChange = function () {
                    this[document.hidden ? "pause" : "unpause"]();
                }),
                (e.prototype.visibilityPlay = function () {
                    this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
                }),
                Object.assign(t.defaults, { pauseAutoPlayOnHover: !0 }),
                (t.create.player = function () {
                    (this.player = new e(this.options.autoPlay, () => {
                        this.next(!0);
                    })),
                        this.on("activate", this.activatePlayer),
                        this.on("uiChange", this.stopPlayer),
                        this.on("pointerDown", this.stopPlayer),
                        this.on("deactivate", this.deactivatePlayer);
                });
            let i = t.prototype;
            return (
                (i.activatePlayer = function () {
                    this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
                }),
                (i.playPlayer = function () {
                    this.player.play();
                }),
                (i.stopPlayer = function () {
                    this.player.stop();
                }),
                (i.pausePlayer = function () {
                    this.player.pause();
                }),
                (i.unpausePlayer = function () {
                    this.player.unpause();
                }),
                (i.deactivatePlayer = function () {
                    this.player.stop(), this.element.removeEventListener("mouseenter", this);
                }),
                (i.onmouseenter = function () {
                    this.options.pauseAutoPlayOnHover &&
                        (this.player.pause(), this.element.addEventListener("mouseleave", this));
                }),
                (i.onmouseleave = function () {
                    this.player.unpause(), this.element.removeEventListener("mouseleave", this);
                }),
                (t.Player = e),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(n.exports, l.exports)) : i(e.Flickity, e.fizzyUIUtils);
        })("undefined" != typeof window ? window : i, function (t, e) {
            let i = t.prototype;
            return (
                (i.insert = function (t, e) {
                    let i = this._makeCells(t);
                    if (!i || !i.length) return;
                    let s = this.cells.length;
                    e = void 0 === e ? s : e;
                    let n = (function (t) {
                            let e = document.createDocumentFragment();
                            return t.forEach((t) => e.appendChild(t.element)), e;
                        })(i),
                        o = e === s;
                    if (o) this.slider.appendChild(n);
                    else {
                        let t = this.cells[e].element;
                        this.slider.insertBefore(n, t);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (o) this.cells = this.cells.concat(i);
                    else {
                        let t = this.cells.splice(e, s - e);
                        this.cells = this.cells.concat(i).concat(t);
                    }
                    this._sizeCells(i), this.cellChange(e), this.positionSliderAtSelected();
                }),
                (i.append = function (t) {
                    this.insert(t, this.cells.length);
                }),
                (i.prepend = function (t) {
                    this.insert(t, 0);
                }),
                (i.remove = function (t) {
                    let i = this.getCells(t);
                    if (!i || !i.length) return;
                    let s = this.cells.length - 1;
                    i.forEach((t) => {
                        t.remove();
                        let i = this.cells.indexOf(t);
                        (s = Math.min(i, s)), e.removeFrom(this.cells, t);
                    }),
                        this.cellChange(s),
                        this.positionSliderAtSelected();
                }),
                (i.cellSizeChange = function (t) {
                    let e = this.getCell(t);
                    if (!e) return;
                    e.getSize();
                    let i = this.cells.indexOf(e);
                    this.cellChange(i);
                }),
                (i.cellChange = function (t) {
                    let e = this.selectedElement;
                    this._positionCells(t), this._updateWrapShiftCells(), this.setGallerySize();
                    let i = this.getCell(e);
                    i && (this.selectedIndex = this.getCellSlideIndex(i)),
                        (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                        this.emitEvent("cellChange", [t]),
                        this.select(this.selectedIndex);
                }),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(n.exports, l.exports)) : i(e.Flickity, e.fizzyUIUtils);
        })("undefined" != typeof window ? window : i, function (t, e) {
            const i = "data-flickity-lazyload",
                s = `${i}-src`,
                n = `${i}-srcset`,
                o = `img[${i}], img[${s}], img[${n}], source[${n}]`;
            t.create.lazyLoad = function () {
                this.on("select", this.lazyLoad), (this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this));
            };
            let r = t.prototype;
            function l(t) {
                if (t.matches("img")) {
                    let e = t.getAttribute(i),
                        o = t.getAttribute(s),
                        r = t.getAttribute(n);
                    if (e || o || r) return t;
                }
                return [...t.querySelectorAll(o)];
            }
            function a(t, e) {
                (this.img = t), (this.onComplete = e), this.load();
            }
            return (
                (r.lazyLoad = function () {
                    let { lazyLoad: t } = this.options;
                    if (!t) return;
                    let e = "number" == typeof t ? t : 0;
                    this.getAdjacentCellElements(e)
                        .map(l)
                        .flat()
                        .forEach((t) => new a(t, this.handleLazyLoadComplete));
                }),
                (r.onLazyLoadComplete = function (t, e) {
                    let i = this.getParentCell(t),
                        s = i && i.element;
                    this.cellSizeChange(s), this.dispatchEvent("lazyLoad", e, s);
                }),
                (a.prototype.handleEvent = e.handleEvent),
                (a.prototype.load = function () {
                    this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                    let t = this.img.getAttribute(i) || this.img.getAttribute(s),
                        e = this.img.getAttribute(n);
                    (this.img.src = t),
                        e && this.img.setAttribute("srcset", e),
                        this.img.removeAttribute(i),
                        this.img.removeAttribute(s),
                        this.img.removeAttribute(n);
                }),
                (a.prototype.onload = function (t) {
                    this.complete(t, "flickity-lazyloaded");
                }),
                (a.prototype.onerror = function (t) {
                    this.complete(t, "flickity-lazyerror");
                }),
                (a.prototype.complete = function (t, e) {
                    this.img.removeEventListener("load", this),
                        this.img.removeEventListener("error", this),
                        (this.img.parentNode.matches("picture") ? this.img.parentNode : this.img).classList.add(e),
                        this.onComplete(this.img, t);
                }),
                (t.LazyLoader = a),
                t
            );
        });
    })({ exports: {} });
    var u = { exports: {} };
    /*!
     * imagesLoaded v5.0.0
     * JavaScript is all like "You images are done yet or what?"
     * MIT License
     */
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(e, o.exports)) : (e.imagesLoaded = i(e, e.EvEmitter));
        })("undefined" != typeof window ? window : i, function (t, e) {
            let i = t.jQuery,
                s = t.console;
            function n(t, e, o) {
                if (!(this instanceof n)) return new n(t, e, o);
                let r = t;
                var l;
                ("string" == typeof t && (r = document.querySelectorAll(t)), r)
                    ? ((this.elements =
                          ((l = r),
                          Array.isArray(l) ? l : "object" == typeof l && "number" == typeof l.length ? [...l] : [l])),
                      (this.options = {}),
                      "function" == typeof e ? (o = e) : Object.assign(this.options, e),
                      o && this.on("always", o),
                      this.getImages(),
                      i && (this.jqDeferred = new i.Deferred()),
                      setTimeout(this.check.bind(this)))
                    : s.error(`Bad element for imagesLoaded ${r || t}`);
            }
            (n.prototype = Object.create(e.prototype)),
                (n.prototype.getImages = function () {
                    (this.images = []), this.elements.forEach(this.addElementImages, this);
                });
            const o = [1, 9, 11];
            n.prototype.addElementImages = function (t) {
                "IMG" === t.nodeName && this.addImage(t),
                    !0 === this.options.background && this.addElementBackgroundImages(t);
                let { nodeType: e } = t;
                if (!e || !o.includes(e)) return;
                let i = t.querySelectorAll("img");
                for (let t of i) this.addImage(t);
                if ("string" == typeof this.options.background) {
                    let e = t.querySelectorAll(this.options.background);
                    for (let t of e) this.addElementBackgroundImages(t);
                }
            };
            const r = /url\((['"])?(.*?)\1\)/gi;
            function l(t) {
                this.img = t;
            }
            function a(t, e) {
                (this.url = t), (this.element = e), (this.img = new Image());
            }
            return (
                (n.prototype.addElementBackgroundImages = function (t) {
                    let e = getComputedStyle(t);
                    if (!e) return;
                    let i = r.exec(e.backgroundImage);
                    for (; null !== i; ) {
                        let s = i && i[2];
                        s && this.addBackground(s, t), (i = r.exec(e.backgroundImage));
                    }
                }),
                (n.prototype.addImage = function (t) {
                    let e = new l(t);
                    this.images.push(e);
                }),
                (n.prototype.addBackground = function (t, e) {
                    let i = new a(t, e);
                    this.images.push(i);
                }),
                (n.prototype.check = function () {
                    if (((this.progressedCount = 0), (this.hasAnyBroken = !1), !this.images.length))
                        return void this.complete();
                    let t = (t, e, i) => {
                        setTimeout(() => {
                            this.progress(t, e, i);
                        });
                    };
                    this.images.forEach(function (e) {
                        e.once("progress", t), e.check();
                    });
                }),
                (n.prototype.progress = function (t, e, i) {
                    this.progressedCount++,
                        (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
                        this.emitEvent("progress", [this, t, e]),
                        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
                        this.progressedCount === this.images.length && this.complete(),
                        this.options.debug && s && s.log(`progress: ${i}`, t, e);
                }),
                (n.prototype.complete = function () {
                    let t = this.hasAnyBroken ? "fail" : "done";
                    if (
                        ((this.isComplete = !0),
                        this.emitEvent(t, [this]),
                        this.emitEvent("always", [this]),
                        this.jqDeferred)
                    ) {
                        let t = this.hasAnyBroken ? "reject" : "resolve";
                        this.jqDeferred[t](this);
                    }
                }),
                (l.prototype = Object.create(e.prototype)),
                (l.prototype.check = function () {
                    this.getIsImageComplete()
                        ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                        : ((this.proxyImage = new Image()),
                          this.img.crossOrigin && (this.proxyImage.crossOrigin = this.img.crossOrigin),
                          this.proxyImage.addEventListener("load", this),
                          this.proxyImage.addEventListener("error", this),
                          this.img.addEventListener("load", this),
                          this.img.addEventListener("error", this),
                          (this.proxyImage.src = this.img.currentSrc || this.img.src));
                }),
                (l.prototype.getIsImageComplete = function () {
                    return this.img.complete && this.img.naturalWidth;
                }),
                (l.prototype.confirm = function (t, e) {
                    this.isLoaded = t;
                    let { parentNode: i } = this.img,
                        s = "PICTURE" === i.nodeName ? i : this.img;
                    this.emitEvent("progress", [this, s, e]);
                }),
                (l.prototype.handleEvent = function (t) {
                    let e = "on" + t.type;
                    this[e] && this[e](t);
                }),
                (l.prototype.onload = function () {
                    this.confirm(!0, "onload"), this.unbindEvents();
                }),
                (l.prototype.onerror = function () {
                    this.confirm(!1, "onerror"), this.unbindEvents();
                }),
                (l.prototype.unbindEvents = function () {
                    this.proxyImage.removeEventListener("load", this),
                        this.proxyImage.removeEventListener("error", this),
                        this.img.removeEventListener("load", this),
                        this.img.removeEventListener("error", this);
                }),
                (a.prototype = Object.create(l.prototype)),
                (a.prototype.check = function () {
                    this.img.addEventListener("load", this),
                        this.img.addEventListener("error", this),
                        (this.img.src = this.url),
                        this.getIsImageComplete() &&
                            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
                }),
                (a.prototype.unbindEvents = function () {
                    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                }),
                (a.prototype.confirm = function (t, e) {
                    (this.isLoaded = t), this.emitEvent("progress", [this, this.element, e]);
                }),
                (n.makeJQueryPlugin = function (e) {
                    (e = e || t.jQuery) &&
                        ((i = e),
                        (i.fn.imagesLoaded = function (t, e) {
                            return new n(this, t, e).jqDeferred.promise(i(this));
                        }));
                }),
                n.makeJQueryPlugin(),
                n
            );
        });
    })(u),
        (function (t) {
            !(function (e, i) {
                t.exports ? (t.exports = i(n.exports, u.exports)) : i(e.Flickity, e.imagesLoaded);
            })("undefined" != typeof window ? window : i, function (t, e) {
                return (
                    (t.create.imagesLoaded = function () {
                        this.on("activate", this.imagesLoaded);
                    }),
                    (t.prototype.imagesLoaded = function () {
                        if (!this.options.imagesLoaded) return;
                        e(this.slider).on("progress", (t, e) => {
                            let i = this.getParentCell(e.img);
                            this.cellSizeChange(i && i.element),
                                this.options.freeScroll || this.positionSliderAtSelected();
                        });
                    }),
                    t
                );
            });
        })({ exports: {} }),
        /*!
         * Flickity v3.0.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2022 Metafizzy
         */
        (function (t) {
            if (t.exports) {
                const e = n.exports;
                t.exports = e;
            }
        })(s),
        /*!
         * Flickity asNavFor v3.0.0
         * enable asNavFor for Flickity
         */
        (function (t) {
            !(function (e, i) {
                t.exports ? (t.exports = i(s.exports, l.exports)) : (e.Flickity = i(e.Flickity, e.fizzyUIUtils));
            })(window, function (t, e) {
                t.create.asNavFor = function () {
                    this.on("activate", this.activateAsNavFor),
                        this.on("deactivate", this.deactivateAsNavFor),
                        this.on("destroy", this.destroyAsNavFor);
                    let t = this.options.asNavFor;
                    t &&
                        setTimeout(() => {
                            this.setNavCompanion(t);
                        });
                };
                let i = t.prototype;
                return (
                    (i.setNavCompanion = function (i) {
                        i = e.getQueryElement(i);
                        let s = t.data(i);
                        s &&
                            s !== this &&
                            ((this.navCompanion = s),
                            (this.onNavCompanionSelect = () => {
                                this.navCompanionSelect();
                            }),
                            s.on("select", this.onNavCompanionSelect),
                            this.on("staticClick", this.onNavStaticClick),
                            this.navCompanionSelect(!0));
                    }),
                    (i.navCompanionSelect = function (t) {
                        let e = this.navCompanion && this.navCompanion.selectedCells;
                        if (!e) return;
                        let i = e[0],
                            s = this.navCompanion.cells.indexOf(i),
                            n = s + e.length - 1,
                            o = Math.floor(((r = s), (l = n), (a = this.navCompanion.cellAlign), (l - r) * a + r));
                        var r, l, a;
                        if ((this.selectCell(o, !1, t), this.removeNavSelectedElements(), o >= this.cells.length))
                            return;
                        let h = this.cells.slice(s, n + 1);
                        (this.navSelectedElements = h.map((t) => t.element)), this.changeNavSelectedClass("add");
                    }),
                    (i.changeNavSelectedClass = function (t) {
                        this.navSelectedElements.forEach(function (e) {
                            e.classList[t]("is-nav-selected");
                        });
                    }),
                    (i.activateAsNavFor = function () {
                        this.navCompanionSelect(!0);
                    }),
                    (i.removeNavSelectedElements = function () {
                        this.navSelectedElements &&
                            (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
                    }),
                    (i.onNavStaticClick = function (t, e, i, s) {
                        "number" == typeof s && this.navCompanion.selectCell(s);
                    }),
                    (i.deactivateAsNavFor = function () {
                        this.removeNavSelectedElements();
                    }),
                    (i.destroyAsNavFor = function () {
                        this.navCompanion &&
                            (this.navCompanion.off("select", this.onNavCompanionSelect),
                            this.off("staticClick", this.onNavStaticClick),
                            delete this.navCompanion);
                    }),
                    t
                );
            });
        })({ exports: {} }),
        customElements.get("product-info") ||
            customElements.define(
                "product-info",
                class extends HTMLElement {
                    quantityInput = void 0;
                    quantityForm = void 0;
                    onVariantChangeUnsubscriber = void 0;
                    cartUpdateUnsubscriber = void 0;
                    abortController = void 0;
                    pendingRequestUrl = null;
                    preProcessHtmlCallbacks = [];
                    postProcessHtmlCallbacks = [];
                    currentVariant = null;
                    constructor() {
                        super(),
                            (this.quantityInput = this.querySelector("[data-quantity-input]")),
                            (this.productImages = this.querySelector("product-images")),
                            (this.productMediaList = this.querySelector("[data-product-media-list]")),
                            (this.productFormWrapper = this.querySelector("[data-form-wrapper]")),
                            (this.productForm = this.querySelector("product-form")),
                            (this.priceContainer = this.querySelector("[data-product-price]"));
                    }
                    connectedCallback() {
                        this.initializeProductSwapUtility(),
                            this.recordRecentlyViewed(),
                            (this.onVariantChangeUnsubscriber = subscribe(
                                theme.PUB_SUB_EVENTS.optionValueSelectionChange,
                                this.handleOptionValueChange.bind(this)
                            )),
                            this.initQuantityHandlers(),
                            this.initProductNotificationHandlers(),
                            this.dispatchEvent(new CustomEvent("theme:product-info:loaded", { bubbles: !0 })),
                            this.updatePreorderState(),
                            this.checkLiveCartInfo(),
                            (this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo()),
                            document.addEventListener("theme:cart-drawer:close", this.checkLiveCartInfoCallback);
                    }
                    recordRecentlyViewed() {
                        try {
                            if (!window.Shopify?.Products?.recordRecentlyViewed) return;
                            const t = this.dataset.productHandle;
                            t
                                ? window.Shopify.Products.recordRecentlyViewed({ handle: t })
                                : window.Shopify.Products.recordRecentlyViewed();
                        } catch (t) {
                            console.warn("Recently viewed recording error:", t);
                        }
                    }
                    checkLiveCartInfo() {
                        const t = this.productForm?.variantIdInput?.value;
                        if (!t) return;
                        const e = parseInt(this.quantityInput?.value, 10) || 1,
                            i = `${theme.routes.root}products/${this.dataset.productHandle}?section_id=api-live-cart-info&variant=${t}`;
                        fetch(i)
                            .then((t) => t.text())
                            .then((t) => {
                                const i = new DOMParser().parseFromString(t, "text/html"),
                                    s = i.querySelector("[data-item-count-for-variant]"),
                                    n = i.querySelector("[data-max-inventory]");
                                if (!s || !n) return;
                                const o = Number(s.textContent),
                                    r = n.textContent,
                                    l = Number(r),
                                    a = "" !== r && e + o > l,
                                    h = "" !== r && o === l ? "form" : "cart",
                                    c = this.querySelector("[data-product-form]");
                                c &&
                                    (c.setAttribute("data-max-inventory-reached", a),
                                    c.setAttribute("data-error-message-position", h));
                            })
                            .catch((t) => {
                                console.warn("Failed to check live cart info:", t);
                            });
                    }
                    addPreProcessCallback(t) {
                        this.preProcessHtmlCallbacks.push(t);
                    }
                    initQuantityHandlers() {
                        this.quantityInput &&
                            ((this.quantityForm = this.querySelector(".product-form__quantity")),
                            this.quantityForm &&
                                (this.setQuantityBoundaries(),
                                this.quantityInput.addEventListener("change", () => {
                                    this.checkLiveCartInfo();
                                    const t = this.currentVariant ?? this.getSelectedVariant(this);
                                    this.updateButtonPrice(t, !1);
                                }),
                                this.dataset.originalSection ||
                                    (this.cartUpdateUnsubscriber = subscribe(
                                        theme.PUB_SUB_EVENTS.cartUpdate,
                                        this.fetchQuantityRules.bind(this)
                                    ))));
                    }
                    disconnectedCallback() {
                        this.abortController?.abort(),
                            this.onVariantChangeUnsubscriber?.(),
                            this.cartUpdateUnsubscriber?.(),
                            document.removeEventListener("theme:cart-drawer:close", this.checkLiveCartInfoCallback);
                    }
                    initializeProductSwapUtility() {
                        this.postProcessHtmlCallbacks.push(() => {
                            window?.Shopify?.PaymentButton?.init(), window?.ProductModel?.loadShopifyXR();
                        });
                    }
                    handleOptionValueChange({ data: { event: t, target: e, selectedOptionValues: i } }) {
                        if (!this.contains(t.target)) return;
                        this.resetProductFormState();
                        const s = e.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
                        this.pendingRequestUrl = s;
                        const n = this.dataset.url !== s,
                            o = "true" === this.dataset.updateUrl && n;
                        this.renderProductInfo({
                            requestUrl: this.buildRequestUrlWithParams(s, i, o),
                            targetId: e.id,
                            callback: n ? this.handleSwapProduct(s, o) : this.handleUpdateProductInfo(s),
                        });
                    }
                    resetProductFormState() {
                        this.productForm?.toggleSubmitButton(!0);
                    }
                    handleSwapProduct(t, e) {
                        return (i) => {
                            this.productModal?.remove();
                            const s = e ? "product-info[id^='MainProduct']" : "product-info",
                                n = this.getSelectedVariant(i.querySelector(s));
                            if ((this.updateURL(t, n?.id), e)) {
                                const t = i.querySelector("head title"),
                                    e = document.querySelector("head title");
                                t && e && (e.textContent = t.textContent),
                                    HTMLUpdateUtility.viewTransition(
                                        document.querySelector("main"),
                                        i.querySelector("main"),
                                        this.preProcessHtmlCallbacks,
                                        this.postProcessHtmlCallbacks
                                    );
                            } else
                                HTMLUpdateUtility.viewTransition(
                                    this,
                                    i.querySelector("product-info"),
                                    this.preProcessHtmlCallbacks,
                                    this.postProcessHtmlCallbacks
                                );
                        };
                    }
                    renderProductInfo({ requestUrl: t, targetId: e, callback: i }) {
                        this.abortController?.abort(),
                            (this.abortController = new AbortController()),
                            fetch(t, { signal: this.abortController.signal })
                                .then((t) => t.text())
                                .then((t) => {
                                    this.pendingRequestUrl = null;
                                    const e = new DOMParser().parseFromString(t, "text/html");
                                    i(e);
                                })
                                .then(() => {
                                    document.querySelector(`#${e}`)?.focus();
                                })
                                .catch((t) => {
                                    "AbortError" !== t.name && console.error(t);
                                });
                    }
                    getSelectedVariant(t) {
                        const e = t.querySelector("[data-selected-variant]")?.textContent;
                        return e ? JSON.parse(e) : null;
                    }
                    buildRequestUrlWithParams(t, e, i = !1) {
                        const s = [];
                        return (
                            i || s.push(`section_id=${this.sectionId}`),
                            e.length && s.push(`option_values=${e.join(",")}`),
                            `${t}?${s.join("&")}`
                        );
                    }
                    updateOptionValues(t) {
                        const e = t.querySelector("variant-selects");
                        e && HTMLUpdateUtility.viewTransition(this.variantSelectors, e, this.preProcessHtmlCallbacks);
                    }
                    showSoldoutNotificationButton(t) {
                        this.productFormWrapper?.classList.contains("show-product-notification") &&
                            this.productFormWrapper.classList.toggle("variant--soldout", t);
                    }
                    updatePreorderState(t = this) {
                        (this.submitButton = t.querySelector(`#ProductSubmitButton-${this.sectionId}`)),
                            (this.isPreorder = "true" === this.submitButton?.dataset.preorder),
                            (this.preorderInput = this.querySelector("[data-product-preorder]")),
                            this.preorderInput && (this.preorderInput.disabled = !this.isPreorder);
                    }
                    updateButtonPrice(t, e) {
                        if (!window.theme.settings.atcButtonShowPrice) return;
                        const i = this.productForm?.submitButtonText?.querySelector("[data-product-price]");
                        if (!i) return;
                        if (!t || e) return void (i.style.display = "none");
                        i.style.display = "";
                        const s = (this.quantityInput && parseInt(this.quantityInput.value || "1", 10)) || 1,
                            n = (t.price || 0) * s,
                            o = t.compare_at_price > t.price ? t.compare_at_price * s : 0,
                            r = window.theme.settings.currencyCodeEnable
                                ? window.theme.moneyWithCurrencyFormat
                                : window.theme.moneyWithoutCurrencyFormat,
                            l = 0 === n ? window.theme.strings.free : window.theme.formatMoney(n, r);
                        i.innerHTML = o ? `${l} <s>${window.theme.formatMoney(o, r)}</s>` : l;
                    }
                    handleUpdateProductInfo(t) {
                        return (e) => {
                            const i = this.getSelectedVariant(e);
                            if (
                                (this.pickupAvailability?.update(i),
                                this.updateOptionValues(e),
                                this.updateURL(t, i?.id),
                                this.updateVariantInputs(i?.id),
                                !i)
                            )
                                return void this.setUnavailable();
                            this.updatePreorderState(e);
                            const s = !this.submitButton || this.submitButton.hasAttribute("disabled");
                            this.applySubmitButtonState(s),
                                (this.currentVariant = i),
                                this.updateQuantityRules(this.sectionId, e),
                                this.updateButtonPrice(i, s),
                                this.updateMedia(i?.featured_media?.id),
                                this.copySourceIntoDestination(e, "Price"),
                                this.copySourceIntoDestination(e, "Sku", ({ classList: t }) => t.contains("hidden")),
                                this.copySourceIntoDestination(e, "Inventory"),
                                this.copySourceIntoDestination(e, "CartBar"),
                                this.copySourceIntoDestination(e, "Badges"),
                                publish(theme.PUB_SUB_EVENTS.variantChange, {
                                    data: { sectionId: this.sectionId, html: e, variant: i },
                                });
                        };
                    }
                    applySubmitButtonState(t) {
                        const { strings: e } = window.theme;
                        this.isPreorder && !t
                            ? (this.productForm?.toggleSubmitButton(!1, e.preOrder),
                              this.showSoldoutNotificationButton(!1))
                            : t
                              ? (this.productForm?.toggleSubmitButton(!0, e.soldOut),
                                this.showSoldoutNotificationButton(!0))
                              : (this.productForm?.toggleSubmitButton(!1, e.addToCart),
                                this.showSoldoutNotificationButton(!1));
                    }
                    copySourceIntoDestination(t, e, i = () => !1) {
                        const s = t.getElementById(`${e}-${this.sectionId}`),
                            n = this.querySelector(`#${e}-${this.dataset.section}`);
                        s && n && ((n.innerHTML = s.innerHTML), n.classList.toggle("hidden", i(s)));
                    }
                    updateVariantInputs(t) {
                        this.querySelectorAll(
                            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
                        ).forEach((e) => {
                            const i = e.querySelector('input[name="id"]');
                            (i.value = t ?? ""), i.dispatchEvent(new Event("change", { bubbles: !0 }));
                        });
                    }
                    updateURL(t, e) {
                        this.querySelector("share-button")?.updateUrl(
                            `${window.theme.routes.shop_url}${t}${e ? `?variant=${e}` : ""}`
                        ),
                            "false" !== this.dataset.updateUrl &&
                                window.history.replaceState({}, "", `${t}${e ? `?variant=${e}` : ""}`);
                    }
                    setUnavailable() {
                        this.productForm?.toggleSubmitButton(!0, window.theme.strings.unavailable),
                            this.updateButtonPrice(null, !0),
                            this.showSoldoutNotificationButton(!1);
                        const t = ["Price", "Inventory", "Sku"].map((t) => `#${t}-${this.dataset.section}`).join(", ");
                        document.querySelectorAll(t).forEach(({ classList: t }) => t.add("hidden"));
                    }
                    updateMedia(t) {
                        if (!t) return;
                        const e = this.querySelector(`[data-image-id="${t}"]`);
                        if (!e) return;
                        const i = e.getAttribute("data-media-id");
                        e.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: !0, detail: { id: i } }));
                    }
                    setQuantityBoundaries() {
                        const t = {
                            cartQuantity: this.quantityInput.dataset.cartQuantity
                                ? parseInt(this.quantityInput.dataset.cartQuantity)
                                : 0,
                            min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
                            max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
                            step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
                        };
                        let e = t.min;
                        const i = null === t.max ? t.max : t.max - t.cartQuantity;
                        null !== i && (e = Math.min(e, i)),
                            t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
                            (this.quantityInput.min = e),
                            i ? (this.quantityInput.max = i) : this.quantityInput.removeAttribute("max"),
                            (this.quantityInput.value = e),
                            publish(theme.PUB_SUB_EVENTS.quantityUpdate, void 0);
                    }
                    fetchQuantityRules() {
                        const t = this.productForm?.variantIdInput?.value;
                        t &&
                            fetch(`${this.dataset.url}?variant=${t}&section_id=${this.dataset.section}`)
                                .then((t) => t.text())
                                .then((t) => {
                                    const e = new DOMParser().parseFromString(t, "text/html");
                                    this.updateQuantityRules(this.dataset.section, e);
                                })
                                .catch((t) => {
                                    console.warn("Failed to fetch quantity rules:", t);
                                });
                    }
                    updateQuantityRules(t, e) {
                        if (!this.quantityInput) return;
                        this.setQuantityBoundaries();
                        const i = e.getElementById(`Quantity-Form-${t}`),
                            s = ["[data-quantity-input]", "[data-quantity-rules]", "[data-quantity-label]"];
                        for (let t of s) {
                            const e = this.quantityForm.querySelector(t),
                                s = i.querySelector(t);
                            if (e && s)
                                if ("[data-quantity-input]" === t) {
                                    const t = ["data-cart-quantity", "data-min", "data-max", "step"];
                                    for (let i of t) {
                                        const t = s.getAttribute(i);
                                        null !== t ? e.setAttribute(i, t) : e.removeAttribute(i);
                                    }
                                } else e.innerHTML = s.innerHTML;
                        }
                    }
                    initProductNotificationHandlers() {
                        const t = this.querySelector("product-notification");
                        if (!t) return;
                        const e = t.closest("popup-component")?.querySelector("[data-popup-open]");
                        this.querySelectorAll("[data-notification-popup-button]")?.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.preventDefault(), e.dispatchEvent(new Event("click"));
                            });
                        });
                    }
                    get productModal() {
                        return document.querySelector(`#ProductModal-${this.dataset.section}`);
                    }
                    get pickupAvailability() {
                        return this.querySelector("pickup-availability");
                    }
                    get variantSelectors() {
                        return this.querySelector("variant-selects");
                    }
                    get relatedProducts() {
                        const t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "related-products");
                        return document.querySelector(`product-recommendations[data-section-id^="${t}"]`);
                    }
                    get quickOrderList() {
                        const t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "quick_order_list");
                        return document.querySelector(`quick-order-list[data-id^="${t}"]`);
                    }
                    get sectionId() {
                        return this.dataset.originalSection || this.dataset.section;
                    }
                }
            ),
        customElements.get("product-model") || customElements.define("product-model", t);
})();
